<template>
	<managing-section class="review-list-by-word" :is-table="true">
		<div slot="topBar">
			<p class="section__info__left">{{ params }}</p>
		</div>
		<table class="table-main">
			<thead>
				<tr>
					<th v-for="th in thList" :key="th">{{ th }}</th>
				</tr>
			</thead>
			<tbody>
				<tr v-for="(item, idx) in list" :key="idx">
					<td class="white-space__nowrap">{{ idx + 1 }}</td>
					<td>{{ item.nickname }}</td>
					<td class="white-space__nowrap">{{ item.rating }}</td>
					<td
						class="review-list-by-word__table__review-text"
						v-html="item.reviewText"
					></td>
					<td class="white-space__nowrap">{{ item.create_date }}</td>
				</tr>
			</tbody>
		</table>
	</managing-section>
</template>

<script>
	import { mapState } from 'vuex';
	import ManagingSection from '@/components/layout/ManagingSection.vue';

	export default {
		name: 'ReviewListByWord',
		components: { ManagingSection },
		data() {
			return {
				thList: ['#', '닉네임', '평점', '리뷰내용', '작성일'],
				list: [],
			};
		},
		computed: {
			...mapState('modal', ['params']),
		},
		created() {
			this.getList();
		},
		methods: {
			async getList() {
				try {
					const name = this.params;
					if (!name) {
						this.list = [];
						return;
					}
					const { data } = await this.$axiosAdmin2.get(
						`/api/analysis/reviews/product/91441/word/${name}`
					);
					this.list = data.reviews.map(item => {
						item.reviewText = item.reviewText =
							item.reviewText.replace(
								new RegExp(name, 'g'),
								`<strong style="color: #066cdf;font-weight: 700;">${name}</strong>`
							);
						return item;
					});
				} catch (err) {
					console.error(err);
					alert(
						'리뷰 목록을 불러오는데 실패했습니댜. 개발팀에 문의하세요.'
					);
				}
			},
		},
	};
</script>

<style lang="scss">
	.review-list-by-word {
		padding-top: 0;

		.review-list-by-word__table__review-text {
			text-align: left;
			line-height: 16px;
		}
	}
</style>
